/**
 * 用户是否可以发帖/弹幕权限
 */
export const CAN_POST = 'CAN_POST';
